// extracted by mini-css-extract-plugin
export default {"packageItem":"fz6VEyO9x53WXpmIsPPl","whiteBg":"hmYT_Rwrlm_QSfIajC38","itemImg":"EBUqZ3h1bnNMC2W45bI6","typography":"B5kPPqEFuHiwjkxXp8IA","spinnerContainer":"ZBbe8wKlfq57HfsQOkiL"};